export const TABLE_TYPE = {
    call: 'call',
    courier: 'courier',
    tariff: 'tariff',
    user: 'user'
};

